import React from "react";
import { Typography } from "@material-ui/core";
import { get } from "lodash";
import { useTranslate } from "react-admin";

const ExpertField = ({
  source,
  record,
  basePath,
  sortBy,
  sortable,
  ...props
}) => {
  const translate = useTranslate();
  const value = get(
    record,
    source,
    translate(`resources.executive-projects.fields.expert_id.empty`)
  );
  return <Typography {...props}>{value}</Typography>;
};
export default ExpertField;
